import { FC, ReactNode, useState, useEffect } from "react";
import clsx from "clsx";

import ArrowIcon from "../../../assets/icons/chevron.svg";

import styles from "./accardion.module.scss";

interface IAccardionOptions {
  children: ReactNode;
  title: string;
  name: string;
};

const allOptions = [
  'worker',
  'dates',
  'contacts',
  'infoProject',
  'infoFired',
  'infoBlocked',
  'migrationCard',
  'patentWork',
  'medBook',
  'recipient',
  'requisites',
  'passportDetails',
  'contactRecipient',
  'infoStructuralUnit',
  'infoWorkCompani',
  'infoPayments'
];

const Accardion: FC<IAccardionOptions> = ({ children, title, name }) => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const openedOptions: string[] = JSON.parse(localStorage.getItem('isOpenedProfileOptions') as string) || allOptions;

    if (openedOptions.includes(name)) {
      setVisible(true);
    }
  }, [name]);

  const handleClickOpen = () => {
    const openedOptions: string[] = JSON.parse(localStorage.getItem('isOpenedProfileOptions') as string) || allOptions;
    let updatedOptions;
    if (visible) {
      updatedOptions = openedOptions.filter(option => option !== name);
    } else {
      updatedOptions = [...openedOptions, name];
    }
    localStorage.setItem('isOpenedProfileOptions', JSON.stringify(updatedOptions));
    setVisible(!visible);
  };

  return (
    <div className={styles.accardion}>
      <div className={styles.accardion__block} onClick={handleClickOpen} >
        <span className='section__title'>{title}</span>
        <div>
          <img src={ArrowIcon} alt="Custom Indicator" className={clsx(styles.icon, visible && styles.icon_open)} />
        </div>
      </div>
      <div className={clsx(styles.accardion__children, visible && styles.accardion__children_visible)}>{children}</div>
    </div>
  )
}

export default Accardion;